import { createSelector } from "@reduxjs/toolkit";
import { selectActiveWorkspaceId } from "@somewear/auth";

import { WorkspaceState } from "../workspace.state";
import { selectAllMeshKeyRotations } from "./workspaceMeshKeyRotations.slice";

const selectWorkspaceMeshKeyRotations = (state: WorkspaceState) => state.workspaceMeshKeyRotations;

export const selectActiveWorkspaceLastMeshKeyRotationEvent = createSelector(
	[selectAllMeshKeyRotations, selectActiveWorkspaceId],
	(meshKeyRotations, workspaceId) => {
		return meshKeyRotations
			.filter((rotation) => rotation.workspaceId === workspaceId)
			.sort((a, b) => (a.requestedTime?.seconds ?? 0) - (b.requestedTime?.seconds ?? 0))
			.last();
	},
);

export const selectIsScheduleLoading = createSelector(
	[selectWorkspaceMeshKeyRotations],
	(workspaceMeshKeyRotations) => {
		return workspaceMeshKeyRotations.isScheduleLoading;
	},
);
